import isEmpty from 'lodash/fp/isEmpty';

// Relies only on cart actions
import {
  LOAD_ADDRESSES_FAILURE,
  LOAD_ADDRESSES_REQUEST,
  LOAD_ADDRESSES_SUCCESS,
  SET_NEW_ADDRESS,
} from 'dux/checkoutAddresses/actionTypes';
import { getNewAddress } from 'dux/checkoutAddresses/selectors';
import { savePumps } from 'dux/checkoutCart/actions';
import { UPDATE_CART_SUCCESS } from 'dux/checkoutCart/actionTypes';
import { patchUser } from 'dux/user/actions';
import { getTextMarketingOptin, getTextOptin, getUserPhone } from 'dux/user/selectors';

import * as CartService from 'Services/CartService';
import * as UserService from 'Services/UserService';

import { fetchSomething } from 'utils/reduxUtils';

/**
 * FETCH
 */

export const loadAddresses = fetchSomething(
  [LOAD_ADDRESSES_REQUEST, LOAD_ADDRESSES_SUCCESS, LOAD_ADDRESSES_FAILURE],
  () => UserService.fetchAddresses()
);

/**
 * PATCH
 */

export const saveContactAddress = ({ values }) => async (dispatch, getState) => {
  try {
    const state = getState();
    const phone = getUserPhone(state);
    const textMarketingOptin = getTextMarketingOptin(state);
    const textOptin = getTextOptin(state);

    await dispatch(savePumps({ values }));

    // Save shipping address if neeeded
    if (values.addressPubkey !== 'newAddress') {
      const data = await CartService.patch({ shipping_address: values.addressPubkey });
      dispatch({ type: UPDATE_CART_SUCCESS, data });
    }

    if (values.addressPubkey === 'newAddress') {
      /**
       * Recovers address from store to recover an eventual pubkey
       * this avoids creating multiple addresses by recursively saving the new address
       */
      const addressToPersist = {
        ...getNewAddress(state),
        ...values.newAddress,
      };
      const address = await UserService.persistAddress(addressToPersist);
      dispatch({
        type: SET_NEW_ADDRESS,
        data: address,
      });

      const data = await CartService.patch({ shipping_address: address.pubkey });
      dispatch({ type: UPDATE_CART_SUCCESS, data });
    }

    const userParams = {};

    if (phone !== values.phone) {
      userParams.phone = values.phone;
    }

    if (typeof values.textOptin === 'boolean' && textOptin !== values.textOptin) {
      userParams.text_optin = values.textOptin;
    }

    if (
      typeof values.textMarketingOptin === 'boolean' &&
      textMarketingOptin !== values.textMarketingOptin
    ) {
      userParams.text_marketing_optin = values.textMarketingOptin;
    }

    // Update user is needed
    if (!isEmpty(userParams)) {
      await dispatch(patchUser(userParams));
    }

    return { status: 'success' };
  } catch (error) {
    return { status: 'failure', addressError: error };
  }
};
